module.exports = __webpack_public_path__ + "img/Baumkirchen.37f2ea1a.jpg";